import { useEffect } from 'react';

export function useAsyncEffect(fetcher: () => Promise<void>, deps?: React.DependencyList) {
  useEffect(() => {
    fetcher();
  }, deps ?? []);
}
